import { gql } from '@apollo/client';

export const SEARCH_EXTERNAL_USERS = gql`
  query SearchExternalUsers($search: String!) {
    persons(
      search: $search
      globalRoleCode: "CLIENT,TAX_ACCOUNTANT,DEMO_CLIENT,UNPAID_CLIENT"
      first: 100
    ) {
      data {
        id
        fullName
        company
        defaultClientRoleId
      }
    }
  }
`;

export const GET_ASSIGNED_PERSONS = gql`
  query GetAssignedPersons($clientId: ID!) {
    client(id: $clientId) {
      id
      attachedPersons {
        clientRoleIds
        person {
          id
          firstName
          lastName
          fullName
          phone
          email
          company
          lastLoginDateTime
          modifiedOn
          assignmentCount
          defaultClientRoleId
          notes
        }
      }
      principalPerson {
        id
        firstName
        lastName
        fullName
        phone
        email
        company
        lastLoginDateTime
        modifiedOn
        assignmentCount
        defaultClientRoleId
        notes
      }
    }
  }
`;

export const GET_CLIENT_ROLES = gql`
  query getClientRoles {
    clientRoles {
      id
      name
      canAccess
    }
  }
`;

export const CREATE_PERSON = gql`
  mutation CreatePerson($person: CreateOrUpdatePerson!) {
    createPerson(person: $person) {
      id
      defaultClientRoleId
    }
  }
`;

export const UPDATE_PERSON = gql`
  mutation UpdatePerson($personId: ID!, $person: CreateOrUpdatePerson!) {
    updatePerson(personId: $personId, person: $person) {
      id
    }
  }
`;

export const REPLACE_PRINCIPAL_PERSON = gql`
  mutation replacePrincipalPerson($clientId: ID!, $personId: ID!) {
    updateClientPrincipalPerson(clientId: $clientId, personId: $personId) {
      id
    }
  }
`;

export const UPDATE_PERSON_CLIENT_ROLES = gql`
  mutation updatePersonClientRoles($clientId: ID!, $personId: ID!, $clientRoleIds: [ID!]) {
    updatePersonClientRoles(clientId: $clientId, personId: $personId, clientRoleIds: $clientRoleIds)
  }
`;

export const DELETE_PERSON_CLIENT_ROLES = gql`
  mutation deleteAllPersonClientRoles($clientId: ID!, $personId: ID!) {
    deleteAllPersonClientRoles(clientId: $clientId, personId: $personId)
  }
`;

export const GET_REASON_FOR_NO_ACCOUNTANT = gql`
  query getClient($clientId: ID!) {
    client(id: $clientId) {
      id
      reasonForNoAccountant
    }
  }
`;

export const UPDATE_REASON_FOR_NO_ACCOUNTANT = gql`
  mutation updateReasonForNoAccountant($clientId: ID!, $reason: String!) {
    updateReasonForNoAccountant(clientId: $clientId, reason: $reason)
  }
`;
